export default __webpack_public_path__ + "assets/34b75ff55e9f11aaf14ecb77485652a5.jpg";